import i18n from "i18next";
import { CategoryTilePicker } from "@/components/shared/CategoryTilePicker/CategoryTilePicker";
import type { DocumentCategory, DocumentClass } from "@/types/documentClass";
import styles from "../DocumentStamp.module.scss";

export interface TypeAndClassProps {
  category: DocumentCategory;
  currentClass: DocumentClass;
  /** Read-only mode — render but don't accept changes. */
  disabled?: boolean;
  onChangeCategory: (next: DocumentCategory) => void;
  /** Click handler for the inline "Change" link inside the tile picker.
   *  Round-1 ships only one canonical class per category, so the link is
   *  hidden inside CategoryTilePicker via an internal gate; we still
   *  forward the handler so it lights up automatically when alternates
   *  arrive. */
  onChangeClassClick?: () => void;
}

/**
 * Section 1 of the popover — "Type & class".
 *
 * Thin wrapper around Team 5's `<CategoryTilePicker showChangeLink />`.
 * The actual tile + link visuals are owned by Team 5; this section just
 * supplies the section header + read-only pip.
 */
export function TypeAndClass({
  category,
  currentClass,
  disabled,
  onChangeCategory,
  onChangeClassClick,
}: TypeAndClassProps) {
  return (
    <div className={styles.section} data-testid="document-stamp-type-and-class">
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>{i18n.t("editor:stamp.typeAmpClass")}</span>
        {disabled && <span className={styles.readOnlyPip}>{i18n.t("editor:stamp.readOnly")}</span>}
      </div>

      <div className={disabled ? styles.muted : undefined}>
        <CategoryTilePicker
          value={category}
          onChange={onChangeCategory}
          showChangeLink
          currentClass={currentClass}
          onChangeClassClick={onChangeClassClick}
        />
      </div>
    </div>
  );
}
